/**
 * mox-stock-pdp-live.js
 * - Pinta cada .mox-talla-stock con (available - qtyEnDraft).
 * - Pinta .mox-stock-mirror según MIRROR_MODE ("draft" | "available" | "remaining").
 * - Reacciona a: carga, cambio de color y eventos de draft.
 * 
 * "draft" → suma de cantidades del usuario (lo que llevas en la draft).
   "available" → suma del disponible real por variante visible.
   "remaining" → suma de (available − enDraft) de las visibles (es lo que antes veías cuando sumabas las celdas de stock). 
 */
(function () {
  if (window.__moxStockLiveInit) return;
  window.__moxStockLiveInit = true;

  const API_BASE = (window.MOX_API_BASE || '').replace(/\/+$/, '');
  // ⬇️ elige qué quieres espejar
  const MIRROR_MODE = (window.MOX_MIRROR_MODE || 'remaining');
  // 'draft' | 'available' | 'remaining'

  // ===== Utils =====
  function normalizeColorStr(str) {
    if (!str) return '';
    return String(str).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();
  }
  function extractColorFromKey(key) {
    if (!key) return '';
    const m = String(key).trim().match(/^\s*\d+\s+(.*)$/);
    return normalizeColorStr(m ? m[1] : key);
  }
  function parseVariantMapFrom(el) {
    const src = el?.dataset?.variantMap || el?.getAttribute?.('data-variant-map');
    if (!src) return null;
    try { return JSON.parse(src); }
    catch { try { return JSON.parse(src.replace(/&quot;/g, '"')); } catch { return null; } }
  }
  // Helper
  // Reemplaza COMPLETO por esta versión
  function resolveEntryByColor(mapObj, selectedColorRaw) {
    if (!mapObj) return null;
    const selectedColor = normalizeColorStr(selectedColorRaw || '');
    if (!selectedColor) return null;

    const keys = Object.keys(mapObj);
    if (!keys.length) return null;

    // “34 CORAL” → bare: “CORAL”, code: “34”
    const bare = selectedColor.replace(/^\s*\d+\s+/, '');
    const codeMatch = selectedColor.match(/^\s*(\d+)\b/);
    const code = codeMatch ? codeMatch[1] : null;

    // 1) Match EXACTO por clave completa (incluye el número si lo hay)
    for (const k of keys) {
      if (normalizeColorStr(k) === selectedColor) return mapObj[k];
    }

    // 2) Match por prefijo numérico/código (34 → "34" o "34 CORAL")
    if (code) {
      for (const k of keys) {
        const nk = String(k).trim().toUpperCase();
        if (nk === code || nk.startsWith(code + ' ')) return mapObj[k];
      }
    }

    // 3) Match por bare como ÚLTIMO recurso (evita colisión 25/34 CORAL)
    if (bare) {
      for (const k of keys) {
        if (extractColorFromKey(k) === bare) return mapObj[k];
      }
    }

    return null;
  }

  function currentColor() {
    // 1) Si la tabla ya tiene el color actual, úsalo
    const tbl = document.querySelector('.mox-talla-table');
    const datasetColor = tbl?.dataset?.matchedColorKey || tbl?.dataset?.currentColor || '';
    if (datasetColor && /\S/.test(datasetColor)) return datasetColor;

    // 2) Radio seleccionado → extraer el valor más expresivo posible
    const radio = document.querySelector('input[type="radio"][name="Color"]:checked');
    if (radio) {
      const label = radio.id ? document.querySelector(`label[for="${radio.id}"]`) : null;
      const candidates = [
        radio.getAttribute('data-option-value'),
        radio.getAttribute('data-color'),
        radio.getAttribute('aria-label'),
        radio.getAttribute('title'),
        (label?.textContent || '').trim(),
        radio.value
      ].filter(Boolean);
      for (const c of candidates) { if (/\S/.test(c)) return c; }
    }

    return '';
  }

  function toNumId(raw) { const m = String(raw || '').match(/(\d+)$/); return m ? m[1] : ''; }

  // Draft → mapa { vidNum -> qty }
  function readDraftQtyMap() {
    const map = new Map();
    try {
      const edges = window.MOX_DRAFT?.state?.draft?.lineItems?.edges;
      const nodes = Array.isArray(edges) ? edges.map(e => e.node) : (window.MOX_DRAFT?.state?.draft?.lineItems?.nodes || []);
      (nodes || []).forEach(li => {
        const vid = toNumId(li?.variant?.id);
        const q = Number(li?.quantity || 0);
        if (vid && q > 0) map.set(vid, (map.get(vid) || 0) + q);
      });
    } catch (_) { }
    return map;
  }

  // Filas visibles (por color) con su variantId real
  function collectVisibleRows() {
    const color = normalizeColorStr(currentColor());
    const matched = [];
    const unmatched = [];

    document.querySelectorAll('.mox-talla-table__row').forEach(row => {
      const input = row.querySelector('.mox-talla-input');
      const stockSpan = row.querySelector('.mox-talla-stock');
      if (!input || !stockSpan) return;

      const mapObj = parseVariantMapFrom(input) || parseVariantMapFrom(stockSpan);
      if (!mapObj) { unmatched.push({ row, stockSpan }); return; }

      const entry = resolveEntryByColor(mapObj, color);
      if (entry && entry.id) {
        matched.push({ row, input, stockSpan, variantId: toNumId(entry.id) });
      } else {
        unmatched.push({ row, stockSpan });
      }
    });

    return { matched, unmatched };
  }


  async function fetchAvailableByVariant(ids) {
    if (!ids.length) return new Map();
    const url = `${API_BASE}/inventory/variants?ids=${encodeURIComponent(ids.join(','))}&shop=babalu-b2b.myshopify.com`;
    const res = await fetch(url, { credentials: 'include' });
    if (!res.ok) throw new Error('Inventario fetch error');
    const json = await res.json();
    if (!json?.ok) throw new Error(json?.error || 'Inventario no OK');
    const m = new Map();
    (json.variants || []).forEach(v => m.set(String(v.id), Number(v.available || 0)));
    return m;
  }

  async function repaint() {
    try {
      const { matched, unmatched } = collectVisibleRows();
      if (!matched.length && !unmatched.length) return;

      const ids = Array.from(new Set(matched.map(r => r.variantId))).filter(Boolean);

      // 1) Inventario real por variante
      const availableMap = await fetchAvailableByVariant(ids);

      // 2) Cantidades en draft por variante
      const draftMap = readDraftQtyMap();

      // 3) Pintar cada fila matcheada y acumular sumas para el espejo
      let sumDraft = 0;
      let sumAvailable = 0;
      let sumRemaining = 0;

      matched.forEach(r => {
        const available = Number(availableMap.get(r.variantId) || 0);
        const inDraft = Number(draftMap.get(r.variantId) || 0);
        const remaining = Math.max(0, available - inDraft);

        r.stockSpan.textContent = String(remaining);

        sumDraft += inDraft;
        sumAvailable += available;
        sumRemaining += remaining;
      });

      // 4) Filas no matcheadas (esa talla no existe para el color actual) → 0
      unmatched.forEach(r => { r.stockSpan.textContent = '0'; });

      // 5) Espejo según modo
      const mirror = document.querySelector('.mox-stock-mirror');
      if (mirror) {
        let value;
        switch (String(MIRROR_MODE).toLowerCase()) {
          case 'draft': value = sumDraft; break;
          case 'available': value = sumAvailable; break;
          default: value = sumRemaining; break;
        }
        mirror.textContent = String(value);
      }
    } catch (e) {
      console.warn('[mox-stock-live] repaint error:', e);
    }
  }


  // Throttle
  function throttle(fn, ms = 150) {
    let last = 0, t;
    return (...args) => {
      const now = Date.now();
      if (now - last >= ms) { last = now; fn(...args); }
      else { clearTimeout(t); t = setTimeout(() => { last = Date.now(); fn(...args); }, ms - (now - last)); }
    };
  }
  const repaintThrottled = throttle(repaint, 120);

  // Boot + hooks
  function boot() {
    repaint();

    // Cambio de color
    document.addEventListener('change', (ev) => {
      const t = ev.target;
      if (t?.matches?.('input[type="radio"][name="Color"]')) repaintThrottled();
    }, true);

    // Eventos de draft del backend
    ['mox:draft:latest', 'mox:draft:updated', 'mox:draft:refreshed', 'mox:draft:changed', 'mox:draft:loaded']
      .forEach(evt => window.addEventListener(evt, repaintThrottled));

    // Cuando el usuario termina de editar
    document.addEventListener('blur', (ev) => {
      if (ev.target?.classList?.contains('mox-talla-input')) setTimeout(repaintThrottled, 0);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();


/* ==========================================================
   Mox · PDP Keep All Slides Visible
   — Quita [hidden]/aria-hidden al cargar y en cada cambio
   — Impide que el theme vuelva a ocultarlas (MutationObserver)
   ========================================================== */



(function () {
  if (window.__moxKeepSlidesVisible) return;
  window.__moxKeepSlidesVisible = true;

  // Utils
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  // Quita atributos de ocultamiento en un contenedor dado
  function unhideSlidesIn(container) {
    if (!container) return;
    $$('.hdt-slider__slide', container).forEach(s => {
      if (s.hasAttribute('hidden')) s.removeAttribute('hidden');
      if (s.hasAttribute('aria-hidden')) s.removeAttribute('aria-hidden');
      // Algunos themes usan style="display:none" puntual
      if (s.style && (s.style.display === 'none')) s.style.display = '';
    });
  }

  // Aplica a todos los sliders del <hdt-product-media>
  function unhideAllInMedia(mediaRoot) {
    if (!mediaRoot) return;
    $$('.hdt-slider__container', mediaRoot).forEach(unhideSlidesIn);
  }

  // Observa y neutraliza cualquier intento del theme por ocultar slides
  function observeContainers(mediaRoot) {
    if (!mediaRoot) return;

    const options = { attributes: true, childList: true, subtree: true, attributeFilter: ['hidden', 'aria-hidden', 'style'] };

    function onMutation(mutations) {
      // Usamos un micro-debounce para agrupar cambios
      if (onMutation._t) cancelAnimationFrame(onMutation._t);
      onMutation._t = requestAnimationFrame(() => {
        // Recorremos otra vez y limpiamos todo
        $$('.hdt-slider__container', mediaRoot).forEach(unhideSlidesIn);
      });
    }

    // Observar contenedores MAIN y THUMBS (si existen)
    const targets = [
      $('.hdt-product-media__main .hdt-slider__container', mediaRoot),
      $('.hdt-product-media__thumb .hdt-slider__container', mediaRoot),
      // respaldo: cualquier container dentro del mediaRoot
      ...$$('.hdt-slider__container', mediaRoot)
    ].filter(Boolean);

    targets.forEach(t => {
      const obs = new MutationObserver(onMutation);
      obs.observe(t, options);
    });
  }

  // Hook para un <hdt-product-media> dado
  function wireMediaRoot(mediaRoot) {
    if (!mediaRoot || mediaRoot.__moxSlidesVisibleWired) return;
    mediaRoot.__moxSlidesVisibleWired = true;

    // 1) Mostrar todo al inicio
    unhideAllInMedia(mediaRoot);

    // 2) Observar cualquier cambio que quiera ocultar
    observeContainers(mediaRoot);

    // 3) Reaplicar en eventos comunes del theme/cambios de variante
    const reapply = () => unhideAllInMedia(mediaRoot);

    // a) Cuando cambia el color activo en el atributo del componente
    const attrObs = new MutationObserver(muts => {
      for (const m of muts) {
        if (m.type === 'attributes' && m.attributeName === 'data-active-color') {
          // pequeño delay para dejar terminar al theme
          setTimeout(reapply, 30);
          break;
        }
      }
    });
    attrObs.observe(mediaRoot, { attributes: true, attributeFilter: ['data-active-color'] });

    // b) Cambios por interacción del usuario (radios/selects)
    document.addEventListener('change', ev => {
      const t = ev.target;
      if (!t) return;
      if (
        t.matches('input[type="radio"][name="Color"]') ||
        t.matches('select[name="id"]') ||
        t.matches('input[name="id"]')
      ) {
        setTimeout(reapply, 30);
      }
    }, true);

    // c) Regreso desde bfcache o resize que pueda rehidratar el slider
    window.addEventListener('pageshow', () => setTimeout(reapply, 30));
    window.addEventListener('resize', () => requestAnimationFrame(reapply));
  }

  // Inicializa para TODOS los <hdt-product-media> de la página
  function boot() {
    const mediaList = $$('hdt-product-media.hdt-product-media');
    mediaList.forEach(wireMediaRoot);

    // Si el theme inserta/rehidrata uno nuevo después, lo enganchamos también
    const bodyObs = new MutationObserver(() => {
      $$('.hdt-product-media.hdt-product-media').forEach(wireMediaRoot);
    });
    bodyObs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
